import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { downloadFile } from '../../../../store/notification/action'
import { useJobConfig } from '../../../JobConfig/JobContext'
import { redirectToViewer } from '../../../../utils/helper'
import { RoutePath } from '../../../../utils/routesHelper'

const RedactConfig = ({ toolName, inputFiles }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { closeToolPopup, docIdExt, tool } = useJobConfig()
  const fileReady = useMemo(
    () => inputFiles[0]?.status === 'finished',
    [inputFiles]
  )

  useEffect(() => {
    const runEffect = async () => {
      try {
        if (fileReady) {
          const file = await dispatch(
            downloadFile({
              name: inputFiles[0].fileName,
              docBlobRef: inputFiles[0].docBlobRef,
              storageType: 'cdoc',
            })
          )
          if (file.error) {
            closeToolPopup && closeToolPopup()
            return
          }
          navigate(RoutePath.RedactEdit, {
            state: { tool, url: file.payload?.url, docIdExt },
          })
        }
      } catch (error) {
        closeToolPopup && closeToolPopup()
      }
    }
    runEffect()
  }, [fileReady])

  return ''
}

export default RedactConfig
